import { JSONSchemaType } from 'ajv'

export interface ICityFormData {
  countryId: string
  stateId: string
  name: string
  code: string
}

const CitySchema: JSONSchemaType<ICityFormData> = {
  type: 'object',
  properties: {
    countryId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    stateId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    code: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
  },
  required: ['countryId', 'stateId', 'name', 'code'],
  additionalProperties: false,
}

export default CitySchema
